import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M6 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM2 7a4 4 0 0 1 7.874-1H20a1 1 0 1 1 0 2H9.874A4.002 4.002 0 0 1 2 7Zm15 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3.874 1A4.002 4.002 0 0 1 21 17a4 4 0 0 1-7.874 1H3a1 1 0 1 1 0-2h10.126Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
